import script from "./EUserOrganizationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EUserOrganizationCard.vue?vue&type=script&setup=true&lang=ts"

import "./EUserOrganizationCard.vue?vue&type=style&index=0&id=3d9bb53a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9bb53a"]])

export default __exports__